import { ComponentProps } from 'react';
import { AsyncBoundary } from '@toss/async-boundary';
import { withAsyncBoundary } from '@toss/async-boundary';
import { ExtendedMapTemplate, MapTemplate } from '@zep/types';
import { MapTemplatesEmpty, TemplateCard, useTemplates } from '@zep/web-components';
const TemplateListSkeleton = () => {
  return <div className="flex flex-col gap-4" data-sentry-component="TemplateListSkeleton" data-sentry-source-file="TemplateList.tsx">
      {Array.from({
      length: 6
    }).map((_, index) => <div key={index} className="flex rounded-[8px] border border-gray-200 bg-white p-4">
          <div className="h-[104px] w-[160px] shrink-0 rounded bg-gray-200" />
          <div className="ml-4 flex flex-1 flex-col justify-between">
            <div>
              <div className="mb-2 h-5 w-3/4 rounded bg-gray-200" />
              <div className="h-4 w-1/2 rounded bg-gray-200" />
            </div>
          </div>
        </div>)}
    </div>;
};
const asyncBoundaryProps: ComponentProps<typeof AsyncBoundary> = {
  pendingFallback: <TemplateListSkeleton />,
  rejectedFallback: () => <div>Error loading templates</div>,
  onError: error => {
    console.error('Error loading templates:', error);
  }
};
export const OfficialTemplateList = withAsyncBoundary((props: TemplateListProps) => {
  const {
    templates
  } = useTemplates({
    categoryId: props.categoryId === -1 ? undefined : props.categoryId,
    isPurchasedView: false,
    suspense: true
  });
  return <TemplateList {...props} templates={templates} categoryId={props.categoryId} selectedTemplateId={props.selectedTemplateId} onSelectTemplate={props.onSelectTemplate} />;
}, asyncBoundaryProps);
export const PurchasedTemplateList = withAsyncBoundary((props: TemplateListProps) => {
  const {
    templates
  } = useTemplates({
    categoryId: props.categoryId === -1 ? undefined : props.categoryId,
    isPurchasedView: true,
    suspense: true
  });
  return <TemplateList {...props} templates={templates} isPurchased={true} selectedTemplateId={props.selectedTemplateId} onSelectTemplate={props.onSelectTemplate} />;
}, asyncBoundaryProps);
const TemplateList = (props: TemplateListProps & {
  templates?: MapTemplate[];
  isPurchased?: boolean;
  categoryId?: number;
  selectedTemplateId?: string | null;
}) => {
  const {
    templates,
    isPurchased = false,
    onSelectTemplate,
    selectedTemplateId
  } = props;
  if (!templates?.length) {
    return <MapTemplatesEmpty isPurchasedMap={isPurchased} variant="page" />;
  }
  return <div className="flex flex-col pr-[10px]" data-sentry-component="TemplateList" data-sentry-source-file="TemplateList.tsx">
      {templates.map(template => <TemplateCard key={template.hashId} template={template} variant="default" isSelected={selectedTemplateId === template.hashId} className="transition-[width] duration-300" onClick={() => {
      if (onSelectTemplate) {
        const extendedTemplate: ExtendedMapTemplate = {
          ...template,
          isPurchased
        };
        onSelectTemplate(extendedTemplate);
      }
    }} />)}
    </div>;
};
export type TemplateListProps = {
  categoryId: number;
  onSelectTemplate?: (mapTemplate: ExtendedMapTemplate) => void;
  selectedTemplateId?: string;
};